/**
 * Consent abstraction layer.
 * 
 * Reads consent state from Consentmo GDPR.
*/

var AttributionConsent = (function () {
  'use strict';

  var ATTR_DEBUG = false;
  var STATUS_COOKIE = 'cookieconsent_status';
  var DISABLED_COOKIE = 'cookieconsent_preferences_disabled';

  function log() {
    if (ATTR_DEBUG) console.log.apply(console, arguments);
  }

  function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf(name + '=') === 0) {
        return decodeURIComponent(c.split('=').slice(1).join('='));
      }
    }
    return null;
  }

  function getDisabledCategories() {
    var disabled = getCookie(DISABLED_COOKIE);
    if (!disabled) return [];

    return disabled
      .split(',')
      .map(function (c) { return c.trim(); })
      .filter(Boolean);
  }

  /**
   * Functionality consent is granted ONLY if:
   * - status cookie exists
   * - functionality is NOT listed as disabled
  */
  function getConsentState() {
    log('[Attribution][Consent] Checking functionality consent');

    try {
      var status = getCookie(STATUS_COOKIE);
      var disabledCategories = getDisabledCategories();

      log('[Attribution][Consent] Status:', status);
      log('[Attribution][Consent] Disabled categories:', disabledCategories);

      if (!status) {
        log('[Attribution][Consent] Consent DENIED (status missing)');
        return 'denied';
      }

      if (status === 'allow') {
        log('[Attribution][Consent] Functionality consent GRANTED (allow)');
        return 'granted';
      }

      if (status === 'accept_selected') {
        if (disabledCategories.indexOf('functionality') !== -1) {
          log('[Attribution][Consent] Functionality consent DENIED (accept_selected with functionality disabled)');
          return 'denied';
        } else {
          log('[Attribution][Consent] Functionality consent GRANTED (accept_selected without functionality disabled)');
          return 'granted';
        }
      }

      log('[Attribution][Consent] Consent DENIED (other status)');
      return 'denied';

    } catch (e) {
      log('[Attribution][Consent] Error reading consent', e);
      return 'denied';
    }
  }

  function getConsentMetadata() {
    var stored = AttributionStorage.read() || {};
    var prevMeta = stored.consentMeta || {};

    var currentStatus = getConsentState();
    var currentDisabled = getDisabledCategories();

    if (!prevMeta.status) {
      return {
        status: currentStatus,
        timestamp: new Date().toISOString(),
        disabled_categories: currentDisabled
      };
    }

    var statusChanged = prevMeta.status !== currentStatus;
    var disabledChanged =
      JSON.stringify(prevMeta.disabled_categories || []) !==
      JSON.stringify(currentDisabled || []);

    if (!statusChanged && !disabledChanged) {
      return prevMeta;
    }

    return {
      status: currentStatus,
      timestamp: new Date().toISOString(),
      disabled_categories: currentDisabled
    };
  }

   function onConsentChange() {
     log('[Attribution][Consent] Consent change detected');

      var stored = AttributionStorage.read();
      if (!stored) return;

      var nextMeta = getConsentMetadata();

      if (
        !stored.consentMeta ||
        stored.consentMeta.timestamp !== nextMeta.timestamp
      ) {
        stored.consentMeta = nextMeta;
        stored.updated_at = new Date().toISOString();
        AttributionStorage.storePayload(stored);

        if (window.AttributionCart?.attachToCart) {
          AttributionCart.attachToCart();
        }
      }
  }

  /**
   * Attach listeners
   */
  function initListeners() {
    if (window.cookieStore && window.cookieStore.addEventListener) {
      window.cookieStore.addEventListener('change', function (event) {
        var relevant = event.changed.some(function (c) {
          return c.name === STATUS_COOKIE || c.name === DISABLED_COOKIE;
        });

        if (relevant) {
          log('[Attribution][Consent] Cookie change detected');
          onConsentChange();
        }
      });
      return;
    }

    // Fallback polling (Safari)
    var lastSnapshot = null;
    setInterval(function () {
      var snapshot = getCookie(STATUS_COOKIE) + '|' + getCookie(DISABLED_COOKIE);
      if (snapshot !== lastSnapshot) {
        lastSnapshot = snapshot;
        log('[Attribution][Consent] Polling change detected');
        onConsentChange();
      }
    }, 500);
  }

  // Auto-init listeners
  initListeners();

  return {
    getConsentState: getConsentState,
    getConsentMetadata: getConsentMetadata,
    getDisabledCategories: getDisabledCategories,
  };

})();